import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/app/[locale]/error.tsx");
